import { useEffect, useState } from "react"
import "./OurConnections.css"

function OurConnections() {
  const [loaded, setLoaded] = useState(false)

  const sources = [
    { name: "Google", domain: "google.com" },
    { name: "Microsoft", domain: "microsoft.com" },
    { name: "Amazon", domain: "amazon.com" },
    { name: "Meta", domain: "meta.com" },
    { name: "GitHub", domain: "github.com" },
    { name: "LinkedIn", domain: "linkedin.com" },
    { name: "Infosys", domain: "infosys.com" },
    { name: "Wipro", domain: "wipro.com" },
    { name: "Coursera", domain: "coursera.org" },
    { name: "Udemy", domain: "udemy.com" },
    { name: "GeeksforGeeks", domain: "geeksforgeeks.org" },
    { name: "LeetCode", domain: "leetcode.com" },
    { name: "HackerRank", domain: "hackerrank.com" },
    { name: "CodeChef", domain: "codechef.com" },
    { name: "StackOverflow", domain: "stackoverflow.com" },
    { name: "YouTube", domain: "youtube.com" }
  ]

  useEffect(() => {
    setLoaded(true)
  }, [])

  const duplicated = [...sources, ...sources]

  return (
    <section className={`connections-section ${loaded ? "loaded" : ""}`}>
      <div className="connections-header">
        <h2>Our Trusted Research & Learning Sources</h2>
        <p>
          We use verified industry platforms and educational resources to gather 
          genuine, up-to-date information. These platforms serve as reference sources 
          for building accurate and reliable career roadmaps.
        </p>
      </div>

      <div className="logo-slider">
        <div className="logo-track">
          {duplicated.map((source, index) => (
            <div className="logo" key={index}>
              <img
                src={`https://logo.clearbit.com/${source.domain}`}
                alt={source.name}
                draggable="false"
                onError={(e) => {
                  e.target.src = `https://www.google.com/s2/favicons?sz=128&domain_url=${source.domain}`
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="connections-disclaimer">
        <p>
          Logos shown are property of their respective owners.
          Displayed for reference purposes only. We are not officially affiliated
          with or endorsed by these organizations.
        </p>
      </div>
    </section>
  )
}

export default OurConnections